// extracted by mini-css-extract-plugin
export var errorIcon = "_qr-1";
export var nameLogo = "_qr-0";